import { Link } from 'react-router-dom'
import { H2, H3, Paragraph, SmallParagraph, SmallText } from '../../components/typography/Typography'
import { ANALYTICS_EVENTS, track } from '../../lib/analytics'
import { FLOOR_SYSTEMS, FLOORING_PATH, coverCourt, colourCourt } from '../Flooring/flooringCatalog'

export const SportsFlooring = () => {
    return (
        <section id='flooring' className='flex flex-col gap-6 md:gap-9'>
            {/* The two finished-court photos ride beside the heading on desktop and
                drop below the card rail on mobile, where there is no room for them. */}
            <div className='flex flex-col gap-3 px-4 md:gap-4 md:px-24 lg:flex-row lg:items-end lg:justify-between lg:gap-16'>
                <div className='flex flex-col gap-3 md:gap-4 lg:max-w-2xl'>
                    <SmallText className='tracking-[0.25em] text-gray-500'>Division 02 — Flooring</SmallText>
                    <H2>Hardwood sports flooring</H2>
                    <Paragraph className='text-gray-600'>
                        A sprung floor built up in layers — damp proof membrane, resilient rubber pads,
                        LVL sleepers, a plywood bearing panel and a hardwood top floor.
                    </Paragraph>
                </div>
                <div className='hidden shrink-0 gap-3 lg:flex'>
                    <img
                        src={coverCourt}
                        alt='Finished hardwood court'
                        loading='lazy'
                        decoding='async'
                        className='h-28 w-44 rounded-xl object-cover'
                    />
                    <img
                        src={colourCourt}
                        alt='Colour infill and line markings'
                        loading='lazy'
                        decoding='async'
                        className='h-28 w-44 rounded-xl object-cover'
                    />
                </div>
            </div>

            {/* Swipes sideways on mobile, four across from `lg` — same rail pattern
                as the product range above. */}
            <div className='ml-4 flex snap-x snap-mandatory gap-4 overflow-x-auto px-4 pb-2 sm:ml-0 sm:grid sm:grid-cols-2 sm:overflow-visible md:px-24 lg:grid-cols-4 [scrollbar-width:none] [&::-webkit-scrollbar]:hidden'>
                {FLOOR_SYSTEMS.map(({ slug, tag, name, description, image }) => (
                    <Link
                        key={slug}
                        to={`${FLOORING_PATH}/${slug}`}
                        onClick={() =>
                            track(ANALYTICS_EVENTS.HOME_FLOORING_CARD_CLICKED, {
                                system: name,
                                destination: `${FLOORING_PATH}/${slug}`,
                            })
                        }
                        className='flex w-[72%] shrink-0 snap-start flex-col overflow-hidden rounded-2xl border border-gray-200 transition-colors hover:border-gray-400 sm:w-auto sm:shrink'
                    >
                        <div className='flex h-32 items-center justify-center bg-gray-100 p-3 md:h-40 md:p-4'>
                            <img
                                src={image}
                                alt={`${name} floor construction`}
                                loading='lazy'
                                decoding='async'
                                className='h-full w-full object-contain'
                            />
                        </div>
                        <div className='flex flex-col gap-2 p-4 md:gap-2.5 md:p-6'>
                            <SmallText className='tracking-[0.18em] text-my-orange'>{tag}</SmallText>
                            <H3 className='font-medium'>{name}</H3>
                            <SmallParagraph className='text-gray-600'>{description}</SmallParagraph>
                        </div>
                    </Link>
                ))}
            </div>

            <div className='flex gap-3 px-4 lg:hidden'>
                <img
                    src={coverCourt}
                    alt='Finished hardwood court'
                    loading='lazy'
                    decoding='async'
                    className='h-28 w-1/2 rounded-xl object-cover'
                />
                <img
                    src={colourCourt}
                    alt='Colour infill and line markings'
                    loading='lazy'
                    decoding='async'
                    className='h-28 w-1/2 rounded-xl object-cover'
                />
            </div>
        </section>
    )
}
